<script setup>
import { useGlobalStore } from '@stores/global'

const global = useGlobalStore()
const props = defineProps({
	image: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<button class="aspect-video w-full overflow-hidden rounded-lg bg-black shadow-lg" @click="global.setModal(['Image', image])">
		<img class="h-full w-full object-cover" :src="image" :alt="image" />
	</button>
</template>
